const Constants = Object.freeze({
    ENVIRONMENT: {
        DEVELOPMENT: process.env.REACT_APP_REDIRECT_URI ?? 'https://clockout.ngrok.app',
        CLOCKOUT_STAGING_API: process.env.REACT_APP_CLOCKOUT_API ?? 'test-api.joinclockout.com',
    },
    CLOCKOUT_API_KEY: '6c1278d308a1b9962ce418e5b66e3b6d',
    CONSUMER_AUTH_TOKEN: 'live-test-secret-token',
});

export default Constants;
